var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpatGuides = function SvgExpatGuides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 87
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ExpatGuides_svg__a",
    d: "M34.55 86.456c18.925 0 36.867-16.555 34.958-35.887C68.725 42.663 67.5 22.846 65.833 0c-7.741 4.952-7.7 4.685-10.433 6.149C52.158 3.639 41.067.745 33.6.745 14.675.745.267 31.83.267 51.263S15.625 86.456 34.55 86.456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ExpatGuides_svg__c",
    d: "M34.55 86.456c18.925 0 36.867-16.555 34.958-35.887C68.725 42.663 67.5 22.846 65.833 0c-7.741 4.952-7.7 4.685-10.433 6.149C52.158 3.639 41.067.745 33.6.745 14.675.745.267 31.83.267 51.263S15.625 86.456 34.55 86.456"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ExpatGuides_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ExpatGuides_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BEEBFF",
    d: "M34.55 86.456c18.925 0 36.867-16.555 34.958-35.887-.783-7.906-1.1-12.39-2.708-35.26-7.758 4.969-7.717 4.701-10.45 6.165-3.242-2.51-14.333-5.396-21.8-5.396C15.625 16.078.283 31.83.283 51.263S15.625 86.456 34.55 86.456",
    mask: "url(#ExpatGuides_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ExpatGuides_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ExpatGuides_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ExpatGuides_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE8700",
    fillRule: "nonzero",
    d: "M41.983 44.705c-.091-.285-.15-.452-.183-.586a2.5 2.5 0 0 1-.775-.276c-.15-.084 0 1.748-.167 1.673-.166-.075 0-.293 0-.31.084 1.891-.466 2.15-.55 2.15-.616-.125-1.958-.451-2.575-.502-.616-.05-9.733-2.09-10.175-2.626L4.167 71.758l3.983 4.643 34.092-27.43a24.4 24.4 0 0 0-.259-4.266M61.775 57.72l.433-.36c.217.11-3.65-1.882-3.4-1.848s.617-1.43.767-1.372-3.075-4.108.142-1.322 3.333-.61 3.766-.31c.125.084-.766-3.99-.625-4.182.909-.996 3.475 2.995 4.267 4.057l19.767 25.673a2.29 2.29 0 0 1-.35 3.154l-3.617 2.978a2.144 2.144 0 0 1-3.017-.276l-19.25-22.47a2.34 2.34 0 0 1-.441-2.09 2.25 2.25 0 0 1 1.45-1.548.4.4 0 0 0 .133-.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DE",
    fillRule: "nonzero",
    d: "m44.242 33.503-3.159 9.445.217 17.525 8.175.084 1.95-17.166.183-7.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    fillRule: "nonzero",
    d: "M44.658 55.839c-.5.326-.083-8.633-.083-8.633l-8.617-3.848 4.775 25.238L57.2 46.27l-5.617-2.77-4.258 4.015s-2.167 7.99-2.667 8.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8700",
    fillRule: "nonzero",
    d: "M65.142 55.01a1.8 1.8 0 0 0-.525.201c-.975.544-3.117 2.385-4.559 8.583-1.925 8.198-6.725 27.389-7.558 30.601-1.392 5.68-1.875 7.863-1.875 7.863L25.833 97.34c.342-1.314.45-10.725 1.667-21.357.933-8.366.7-9.83 1.092-17.936.658-12.874-1.05-13.836-1.05-13.836l13.333-2.15s-2.383 3.003-.833 11.528c.691 4.124 2.241 10.038 3.216 8.917 9.792-11.201 9.467-18.337 9.467-18.337s6.225 2.426 10.15 3.656c3.475 1.112 3.608 4.526 2.267 7.186Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC673",
    fillRule: "nonzero",
    d: "M53.233 46.52a.44.44 0 0 1-.075-.285 6 6 0 0 0-.625-2.426 2.6 2.6 0 0 0-.691-.836c-.7.77-1.159 1.38-1.875 2.1-.884.836-2.642 2.442-2.642 2.442.217.837.567 6.283.567 6.283s4.866-6.743 5.341-7.278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M57.05 24.009a7.2 7.2 0 0 1 2.5.786c.45.343-1.317 3.488-1.792 4.283a.97.97 0 0 1-.375.36 1.84 1.84 0 0 1-1.55-.16c-1.391-.719 1.25-5.27 1.25-5.27zm-15.308-1.423a7.4 7.4 0 0 0-2.575 0c-.525.193.241 3.631.45 4.535a.84.84 0 0 0 .241.443 1.82 1.82 0 0 0 1.542.293c1.467-.26.333-5.279.333-5.279z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M52.5 15.108s3.225 4.584 4.308 7.579c-.833.636-.975.761-.975.761a37.3 37.3 0 0 1-.741 7.002c-.692 2.86-3.609 6.433-3.609 6.433a5.15 5.15 0 0 1 0 2.141c-1.233.653-3.475 2.995-5.708 2.452s-4.383-4.367-5.158-15.845C39.842 14.154 46.192 8.817 52.5 15.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M48.108 14.606s-4.816-3.346-6.5-.653c.692.837 1.484 8.048 1.484 8.048a38 38 0 0 0-.759 7.01c.092 2.945 2.175 7.102 2.175 7.102a3.35 3.35 0 0 0-1.283 2.259c1.075.903 2.967 3.22 5.292 3.162s5.808-2.92 8.983-13.928c3.175-11.01-1.858-17.718-9.392-13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DB",
    fillRule: "nonzero",
    d: "M42.5 30.24c.056.436.296.826.658 1.072.361.234.808.292 1.217.159.53-.142.922-.592.992-1.138.058-.44-.09-.881-.4-1.196a1.4 1.4 0 0 0-1.159-.41A1.43 1.43 0 0 0 42.5 30.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003449",
    fillRule: "nonzero",
    d: "M52.367 26.41a1.09 1.09 0 0 1-.409.836c-.253.21-.59.287-.908.21a1.13 1.13 0 0 1-.833-.77 1.07 1.07 0 0 1 .191-.937c.197-.263.507-.415.834-.41.6-.02 1.102.452 1.125 1.054v.016Zm-5.7-.795a.94.94 0 0 1-.25.677.9.9 0 0 1-.659.293.93.93 0 0 1-.675-.26.98.98 0 0 1 0-1.354.9.9 0 0 1 .65-.285c.51.005.925.416.934.929"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DB",
    fillRule: "nonzero",
    d: "M53.442 30.877a1.43 1.43 0 0 1-.534 1.095c-.325.261-.751.36-1.158.268a1.39 1.39 0 0 1-1.068-.887 1.39 1.39 0 0 1 .235-1.372 1.37 1.37 0 0 1 1.091-.518c.384-.017.757.125 1.034.393.284.268.442.645.433 1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CCC",
    fillRule: "nonzero",
    d: "M49.667 32.006c-.15.226-2.3.05-3.6-.577-.342-.16-.175-.343-.175-.343l2.641-4.651s1.467 4.592 1.134 5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#884F12",
    fillRule: "nonzero",
    d: "M50.925 20.428s-1.175 2.719-.25 2.644A9.26 9.26 0 0 1 55.3 24.26l.833-2.083s-1.6-1.565-5.216-1.673zm-2.992-.351s.275 2.953-.575 2.602a9.3 9.3 0 0 0-4.758-.394l-.15-2.208s2-.979 5.483 0M44.6 9.537c7.375-4.593 21.467 5.671 16.308 5.914S47.083 12.18 47.083 12.18L44.6 9.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CCC",
    fillRule: "nonzero",
    d: "m40.833 22.151.625 3.957c0 .059.784 5.982 7.65 6.751 3.017.343 6.4-3.48 7.642-5.019.267-.878.892-2.961 1.075-4.007l.392.77a14.6 14.6 0 0 1-.584 2.927l-1.391 4.292c-4.025 10.507-8.05 11.26-9.167 11.184-2.017-.133-3.242-1.43-4.733-5.964-1.6-4.852-2.175-13.452-2.175-13.452z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003449",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.54,
    d: "M52.3 34.775s-3.583 3.622-8.417-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#884F12",
    fillRule: "nonzero",
    d: "M42.117 12.013c1.725-3.497 5.866-2.937 4.691-3.28 4.517 1.305 18.542 7.663 17.817 10.14-.275.936-3.925.225-5.392-.603a183 183 0 0 0-.833 5.078l-.308 1.748a9.77 9.77 0 0 1-1.667-6.433C50.883 17.5 44 13.72 44 13.72s1.333 1.364.833 1.531-1.666-.979-1.666-.979a59 59 0 0 1-2.25 8.96l-.692.318S40 16.32 42.117 12.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC673",
    fillRule: "nonzero",
    d: "M39.083 45.022a.4.4 0 0 0 .142-.259 5.9 5.9 0 0 1 1.05-2.334c.226-.28.51-.505.833-.66.509.903.834 1.597 1.392 2.509.692 1.046 2.083 2.97 2.083 2.97-.383.71-1.883 6.006-1.883 6.006s-3.283-7.529-3.633-8.19z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(1.667 37.644)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.192,
    cy: 33.428,
    fill: "#0072A4",
    rx: 29.042,
    ry: 29.848
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.192,
    cy: 33.428,
    fill: "#FFF5F5",
    rx: 21.35,
    ry: 21.951
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9700",
    d: "m20.833 20.704 10.475 7.429a9.53 9.53 0 0 1 3.334 4.283l4.741 12.155A1.33 1.33 0 0 1 39 46.093a1.27 1.27 0 0 1-1.542.067l-10.466-7.445a9.4 9.4 0 0 1-3.334-4.291l-4.716-12.147a1.34 1.34 0 0 1 .4-1.514 1.26 1.26 0 0 1 1.491-.059"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0072A4",
    d: "M19.675 6.324a2.96 2.96 0 0 0 1.987-1.132c.485-.628.7-1.426.596-2.214-.071-.78-.45-1.5-1.053-2a2.93 2.93 0 0 0-2.155-.66 3 3 0 0 0-2.5 3.28 2.995 2.995 0 0 0 3.125 2.684z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M-.225 58.006c.36-.24.77-.392 1.2-.444 1.042-.301 4.3-1.23 4.717-1.246s.891.284.375.836a13 13 0 0 1-2.025 1.406c.923.301 1.88.484 2.85.543 1.091 0 2.291.988 1.15 1.272a27 27 0 0 1-3.659.427 25 25 0 0 0 4.109 1.18c1.166.091 1.158 1.087.6 1.547-.559.46-5.084-.318-5.084-.318a8.1 8.1 0 0 0 2.767 1.313c1.667.418 1.592 1.74.675 1.89-.683.118-4.7-1.162-7.067-1.999a2.88 2.88 0 0 1-1.908-2.267 4.01 4.01 0 0 1 1.3-4.182zm61.333 23.582c1.075-.594 4.742-2.72 4.742-2.72a6.66 6.66 0 0 1 4.4-2.509c-.542-1.255-1.342-2.86-1.858-4.09l-4.434 1.263a46 46 0 0 0-7.65.468c-2.783.544 1.392 1.606 1.392 1.606s-6.667.887-6.742 2.142 6.667 5.789 10.15 3.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8700",
    fillRule: "nonzero",
    d: "M84.425 83.077 62.992 99.339l-2.667-8.809 16.2-11.276z"
  }))))));
};
export default SvgExpatGuides;